import type { ComponentType, SVGProps } from 'react';

import { NAV_SECTIONS } from '@/config/navigation';
import type { Permissions } from '@/context/Permissions';

export type NavCommand = {
	id: string;
	to: string;
	labelKey: string;
	shortcut: string;
	icon: ComponentType<SVGProps<SVGSVGElement>>;
	/** Same optional gate as `NavItem`. Undefined = visible to everyone, which
	 * is how every entry behaved before `/knowledge` existed. */
	permission?: (p: Permissions) => boolean;
};

// Same entries, labels, shortcuts and gates as the sidebar, so the two cannot drift.
export const NAV_COMMANDS: NavCommand[] = NAV_SECTIONS.flatMap((section) =>
	section.items.map((item) => ({
		id: `nav-${item.to}`,
		to: item.to,
		labelKey: `sidebar.${item.labelKey}`,
		shortcut: item.shortcut,
		icon: item.icon,
		permission: item.permission,
	})),
);
